import viewsPages from './views-pages';
import sidebarPages from './sidebar-pages';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  // items: [samplePage, pages],
  items: [viewsPages, sidebarPages],
};

export default menuItems;
